/**
 * Extrae un mensaje de error string de cualquier tipo de error
 */
export const getErrorMessage = (err: any): string => {
  console.error('[error-handler] error', err);
  if (typeof err === 'string') return err;
  const responseData = err?.response?.data;
  const message = responseData?.message;

  if (typeof message === 'string') return message;
  if (Array.isArray(message)) {
    return message.map((item) => (typeof item === 'string' ? item : JSON.stringify(item))).join(', ');
  }
  if (message && typeof message === 'object') {
    if (typeof message.message === 'string') return message.message;
    if (Array.isArray(message.message)) {
      return message.message
        .map((item: unknown) => (typeof item === 'string' ? item : JSON.stringify(item)))
        .join(', ');
    }
    if (typeof message.error === 'string') return message.error;
    return JSON.stringify(message);
  }

  if (typeof responseData?.error === 'string') return responseData.error;
  if (err?.message) return err.message;
  if (typeof err?.data?.message === 'string') return err.data.message;

  if (err?.response?.status === 403) {
    return 'No tienes permisos para realizar esta accion.';
  }

  return 'Error desconocido';
};
